<template>
    <div class="font-set-path" v-click-outside="clickOutsideHandler">
        <div @click="clickIconHandler">
            <iconSymbol class="item-icon" name="font-path-large"></iconSymbol>
        </div>
        <div v-show="show" class="fsp-fontpath">
            <div class="fsp-expandbox">
                <div class="item-wrapper">
                    <div class="fsp-expanditem" v-for="item in fontAroundList" @click="clickAround(item.id)" :key="item.name">
                        <iconSymbol :name="`${item.name}${isDarkTheme() ? '-dark' : ''}`" class="item-icon" />
                        <div class="border"></div>
                    </div>
                </div>
                <div class="fsp-cleanbox" :class="{ ban: !isTextPath }" @click="clickAround(15)">
                    <p>{{ $t("cleanpath") }}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
    import { Component } from "vue-property-decorator";
    import { directive as clickOutside } from "v-click-outside-x";
    import FontPathMixin from "@/app/mixin/fontPathMixin";

    @Component({
        directives: { clickOutside },
    })
    export default class FontSetPath extends FontPathMixin {
        show = false;

        clickIconHandler() {
            if (!this.isSelect) {
                return;
            }
            this.show = !this.show;
        }

        clickOutsideHandler() {
            this.show = false;
        }
    }
</script>

<style lang="stylus" scoped>
    .font-set-path
        position relative
        .fsp-fontpath
            position absolute
            right 0
            top 28px
            z-index 20
            .fsp-expandbox
                display flex
                flex-direction  column
                width 216px
                height 261px
                padding 16px 16px 8px 16px;
                background $ft-bgcolor
                box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.08);
                border-radius $ft-boxradius
                cursor default
                .item-wrapper
                    display grid
                    grid-template-columns repeat(4, 1fr)
                    grid-gap 8px;
                    .fsp-expanditem
                        position relative
                        width 40px
                        height 40px
                        border-radius 6px
                        cursor pointer
                        .border
                            position absolute
                            height 100%;
                            width 100%;
                            top 0;
                            left 0;
                            border-radius 6px
                            border 2px solid var(--themeColor)
                            display none;
                        .item-icon
                            height 40px;
                            width 40px
                        &:not(.active):hover
                            .border
                                display block;

                        &.active
                            .border
                                    display block;

                .fsp-cleanbox
                    width 100%
                    margin-top 16px;
                    padding 14px 0 6px
                    border-top 1px solid var(--border-color-box-6)
                    cursor pointer
                    user-select none
                    p
                        font-size 12px
                        color var(--text-color-primary)
                        line-height 16px
                        textOverflow()

                    &.ban
                        cursor not-allowed

                        p
                            color var(--text-color-tertiary)
</style>

<i18n>
{
    "zh": {
        "fontpath": "路径",
        "cleanpath": "清除路径"
    },
    "en": {
        "fontpath": "Text on path",
        "cleanpath": "None"
    },
    "fr": {
        "fontpath": "Texte sur un chemin",
        "cleanpath": "Chemin clair"
    },
    "de": {
        "fontpath": "Text auf Pfad",
        "cleanpath": "Nichts"
    },
    "jp": {
        "fontpath": "テキストの並べ方",
        "cleanpath": "パスをクリア"
    },
    "es": {
        "fontpath": "Texto en Trazados",
        "cleanpath": "Ninguno"
    },
    "pt": {
        "fontpath": "Texto num caminho",
        "cleanpath": "Nenhum"
    },
    "it": {
        "fontpath": "Testo lungo tracciato",
        "cleanpath": "Nessuna"
    },
    "tw": {
        "fontpath": "線上文本",
        "cleanpath": "清除路徑"
    },
    "kr": {
        "fontpath": "텍스트",
        "cleanpath": "경로 지우기"
    }
}
</i18n>
